import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColorAnimationService } from '@ethic/shared/color-animation';
import { SharedLinks } from '@ethic/shared/configurations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Config } from '../../config';
import { environment } from '../../environments/environment';
import { AppNotification, NotificationService } from '../shared/services/notification.service';
import { isLoginType, LoginTypes } from '../shared/types/login-types';

enum Controls {
  Email = 'user',
  Password = 'pwd',
  Type = 'type',
}

@UntilDestroy()
@Component({
  selector: 'lgn-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  readonly s4eLandingPage = SharedLinks.S4ELandingPage;

  controls = Controls;
  group: FormGroup;
  loginType: LoginTypes;
  returnUrl: string;
  emailControl = new FormControl('', [Validators.email]);
  passwordControl = new FormControl('');
  typeControl = new FormControl('platform');
  environmentSite = environment.environmentSite;

  get isZendeskLogin() {
    return this.loginType === LoginTypes.Zendesk;
  }

  get currentLoginTypeConfig() {
    return this.config.login[this.loginType];
  }

  get formAction() {
    const action = this.currentLoginTypeConfig.action;
    return this.isZendeskLogin ? action : action + '?return_to=' + this.returnUrl;
  }

  constructor(
    public config: Config,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public colorAnimation: ColorAnimationService
  ) {}

  ngOnInit() {
    this.route.queryParamMap.pipe(untilDestroyed(this)).subscribe((paramMap) => {
      const typeParam = paramMap.get('type');
      this.loginType = isLoginType(typeParam) ? typeParam : LoginTypes.Ethic;
      this.returnUrl = paramMap.get('return_to') || '/';
    });
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe(({ notification }: { notification: AppNotification }) => {
        if (notification) {
          this.notificationService.show(notification);
        }
      });

    this.group = this.fb.group({
      [Controls.Email]: this.emailControl,
      [Controls.Password]: this.passwordControl,
    });

    if (this.loginType === LoginTypes.Zendesk) {
      this.group.addControl('type', this.typeControl);
    }
  }

  onUserInput() {
    this.notificationService.clean();
  }
}
